export default __webpack_public_path__ + "static/media/logon_backdrop.67ed7d1c.jpg";